module.exports = __webpack_public_path__ + "static/media/bvlgari-omnia-coral-big.3cd717ce.png";